"use strict";

(function () {
  "use strict";

  angular.module("schedules.planning", ["common"]);
})();